/**
 * Bundle templates — reusable quantity patterns for the Bundle Builder
 * (issue #235). A template is positional (`quantities[0]` = first size of
 * whatever product it's applied to), which is what lets one template serve
 * products whose size lists differ; `colorMode` optionally seeds the
 * Mixed/Single toggle. Colours themselves are never stored — they are always
 * the product's own.
 *
 * @see docs/spec/48-store-bundle-builder.md · R4
 */
import { z } from "zod";
import { uuid } from "../_common.js";

export const templateRow = z.object({
  templateId: uuid,
  name: z.string(),
  quantities: z.array(z.number().int()),
  colorMode: z.enum(["mixed", "single"]).nullable(),
  createdAt: z.string().datetime(),
});

export const listOutput = z.array(templateRow);

export const createInput = z.object({
  name: z.string().trim().min(1).max(32),
  quantities: z.array(z.number().int().min(1).max(1000)).min(1).max(24),
  colorMode: z.enum(["mixed", "single"]).optional(),
});
export const createOutput = z.object({ templateId: uuid });

export const removeInput = z.object({ templateId: uuid });
export const removeOutput = z.object({ templateId: uuid });

export type TemplateRow = z.infer<typeof templateRow>;
export type CreateInput = z.infer<typeof createInput>;
